import ConfigNode from 'Model/ConfigNode'
import { branch } from 'Model/constants'

class RelationSizeParams extends ConfigNode
  @className = 'RelationSizeParams'

  constructor: ->
    super('relationSizeParams')

  @load: ->
    super('relationSizeParams', @)

  update: (key, params = {}) ->
    @set('value', key)
    @save(params)

  key: ->
    @get('value')

  reset: (params = {}) ->
    @update(undefined, params)

export default RelationSizeParams
